module.exports = __webpack_public_path__ + "img/IMG_0656.c2b69ca4.jpeg";